type IconName =
  | "plane" | "calendar" | "tower" | "grad" | "send" | "filter" | "plus"
  | "warn" | "check" | "x" | "chevron" | "clock" | "arrowR" | "wrench"
  | "user" | "users" | "logout" | "sparkle" | "doc" | "star";

const PATHS: Record<IconName, string> = {
  plane: '<path d="M21 12l-7 2-3 7-2-7-7-2 7-2 2-7 3 7 7 2z"/>',
  calendar: '<rect x="3" y="4.5" width="18" height="16" rx="1.5"/><path d="M3 9h18M8 3v3M16 3v3"/>',
  tower: '<path d="M5 21h14M7 21V8l5-4 5 4v13M10 21V14h4v7"/>',
  grad: '<path d="M2 9l10-5 10 5-10 5L2 9z"/><path d="M6 11v5a6 6 0 0012 0v-5"/>',
  send: '<path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/>',
  filter: '<path d="M3 5h18l-7 9v6l-4-2v-4L3 5z"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  warn: '<path d="M12 3l10 18H2L12 3z"/><path d="M12 10v5M12 18v.01"/>',
  check: '<path d="M5 12l5 5 9-10"/>',
  x: '<path d="M6 6l12 12M18 6l-12 12"/>',
  chevron: '<path d="M9 6l6 6-6 6"/>',
  clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
  arrowR: '<path d="M5 12h14M13 6l6 6-6 6"/>',
  wrench: '<path d="M14 7a4 4 0 015 5l6 6-3 3-6-6a4 4 0 01-5-5L8 7l-2 2-4-4 4-4 4 4-2 2z"/>',
  user: '<circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0116 0"/>',
  users: '<circle cx="9" cy="8" r="3.5"/><path d="M2 20a7 7 0 0114 0"/><path d="M16 4a3.5 3.5 0 010 7M22 20a6 6 0 00-4-5.7"/>',
  logout: '<path d="M16 17l5-5-5-5M21 12H9M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/>',
  sparkle: '<path d="M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M5.6 18.4l2.8-2.8M15.6 8.4l2.8-2.8"/>',
  doc: '<path d="M14 3H6a2 2 0 00-2 2v14a2 2 0 002 2h12a2 2 0 002-2V9l-6-6z"/><path d="M14 3v6h6M9 14h6M9 18h4"/>',
  star: '<path d="M12 3l3 6 7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1 3-6z"/>',
};

export function icon(name: IconName, size = 16, sw = 1.6, stroke = "currentColor"): string {
  return `<svg viewBox="0 0 24 24" width="${size}" height="${size}" fill="none" stroke="${stroke}" stroke-width="${sw}" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${PATHS[name]}</svg>`;
}
